import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Web3Provider from './providers/Web3Provider';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import AnimatedBackground from './components/sections/AnimatedBackground';
import MarqueeTicker from './components/sections/MarqueeTicker';
import Hero from './components/sections/Hero';
import DuckStory from './components/sections/DuckStory';
import Tokenomics from './components/sections/Tokenomics';
import HowToBuy from './components/sections/HowToBuy';
import SwapInterface from './components/sections/SwapInterface';
import Roadmap from './components/sections/Roadmap';
import CommunityStats from './components/sections/CommunityStats';
import FAQ from './components/sections/FAQ';
import Memes from './components/sections/Memes';
import AgentDashboard from './components/agent/AgentDashboard';
import ChatBot from './components/sections/ChatBot';
import NotFound from './components/NotFound';

// Home Page Component
const HomePage: React.FC = () => (
    <>
        <Hero />
        <MarqueeTicker />
        <DuckStory />
        <Tokenomics />
        <HowToBuy />
        <SwapInterface />
        <Roadmap />
        <CommunityStats />
        <FAQ />
    </>
);

// Memes Page Component
const MemesPage: React.FC = () => (
    <Memes />
);

// Agent Protocol Page
const AgentPage: React.FC = () => (
    <AgentDashboard />
);

const App: React.FC = () => {
    return (
        <Web3Provider>
            <Router>
                <div style={{ minHeight: '100vh', position: 'relative' }}>
                    <AnimatedBackground />
                    <Navbar />
                    <main>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/memes" element={<MemesPage />} />
                            <Route path="/agents" element={<AgentPage />} />
                            <Route path="*" element={<NotFound />} />
                        </Routes>
                    </main>
                    <ChatBot />
                    <Footer />
                </div>
            </Router>
        </Web3Provider>
    );
};

export default App;
